import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { toolForUrl } from 'src/app/utils/tool-navigation';

@Injectable({
  providedIn: 'root',
})
export class ContextService {
  private pageModeBS = new BehaviorSubject<any>({});
  readonly pageMode = this.pageModeBS.asObservable();

  private pageModeControlerVisibleBS = new BehaviorSubject<any>({});
  readonly pageModeControlerVisible =
    this.pageModeControlerVisibleBS.asObservable();

  constructor(router: Router) {
    // let context = JSON.parse(sessionStorage.getItem('context'));
    // this.setPageMode(null);
    this.setPageModeControlerVisible(false);

    // La URL, no el contexto guardado, determina siempre el módulo activo.
    this.setPageMode(toolForUrl(router.url)?.mode ?? null);
    router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.setPageMode(toolForUrl(event.urlAfterRedirects)?.mode ?? null));
  }

  managePageMode(firstSegment: string) {
    this.setPageMode(toolForUrl('/' + firstSegment)?.mode ?? null);
  }

  setPageMode(pageMode: string) {
    this.pageModeBS.next(pageMode);
    sessionStorage.setItem(
      'context',
      JSON.stringify({
        pageMode: pageMode,
        pageModeControlerVisible: false,
      })
    );
  }

  setPageModeControlerVisible(visible: boolean) {
    this.pageModeControlerVisibleBS.next(visible);
  }
}
